// **********************************************************
// Tabs Slider
// **********************************************************

const tabsSlider = document.querySelectorAll('[data-slider="tabs-slider"]');

const calcTitleWidth = (parentElem) => {
  const titleEle = parentElem.querySelector('.tabs-slider__title');
  const titleWidth = titleEle.offsetWidth;
  parentElem.style.setProperty('--title-width', `${titleWidth}px`);
};

const tabsSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 0,
  watchOverflow: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
};

tabsSlider.forEach((el) => {
  const parentElem = el.closest('.tabs-slider');
  const arrowLeft = parentElem.querySelector('.swiper-button-prev');
  const arrowRight = parentElem.querySelector('.swiper-button-next');
  const sliderNav = parentElem.querySelectorAll('.tabs-slider__arrow');

  tabsSliderOptions.navigation.prevEl = arrowLeft;
  tabsSliderOptions.navigation.nextEl = arrowRight;

  new Swiper(el, tabsSliderOptions);

  calcTitleWidth(parentElem);
  const handleTitleResize = debounce(calcTitleWidth(parentElem), 100);
  window.addEventListener('resize', handleTitleResize);

  setTimeout(() => {
    sliderNav.forEach((arrow) => arrow.classList.remove('d-none'));
  }, 100);
});
